import AnimationComponent from '../Component/Animation';
import Interactable from '../Component/Interactable';
import RelativePositionComponent from '../Component/Render/RelativePosition';
import Game from '../Game';
import GameObject from '../GameObject/GameObject';
import Armature from '../Prototype/Armature';
import Container from '../Prototype/Container';
import Text from '../Prototype/Text';
import Overlay from '../Prototype/UI/Overlay';
import { SceneTransition } from '../Scene/SceneManager';
import { IGameState } from '../State/Game/IGameState';
import Point from '../Utility/Point';
import {
    GetAnimationClip,
    PlayAnimation,
    StartAnimation,
} from './Animation/AnimationHelper';
import System from './System';

export default class TransitionSystem extends System {
    public container: Container;
    public overlay: Overlay;
    public armature: Armature;
    public loadingText: Text;

    public onStart(): void {
        this.scene.once(SceneTransition.START, () => {
            this.startCoroutine(this.transitionIn());
        });

        this.scene.once(SceneTransition.END, () => {
            this.startCoroutine(this.transitionOut());
        });

        this.createObjects();
    }

    private createObjects() {
        this.container = GameObject.Instantiate(Container, {
            name: 'PreloaderContainer',
            alpha: 0,
        });

        this.container.addComponent(AnimationComponent);

        this.overlay = GameObject.Instantiate(Overlay, {
            color: [255, 255, 255, 255],
            alpha: 1,
        });

        this.loadingText = GameObject.Instantiate(Text, {
            text: Game.locale.getText('Loading'),
            style: Game.style.getStyle('loading.text'),
            anchor: new Point(0.5, 0.5),
            position: new Point(0, 225),
        });

        this.loadingText.addComponent(RelativePositionComponent, {
            relativePosition: new Point(0.5, 0.5),
        });

        this.armature = GameObject.Instantiate<Armature>(Armature, {
            dragonbonesName: 'ScreenTransitions',
            armatureName: 'LoadingScreen',
            animationName: 'animation',
            position: new Point(0, -75),
        });

        this.armature.addComponent(RelativePositionComponent, {
            relativePosition: new Point(0.5, 0.5),
        });

        this.container.addChild(this.overlay);
        this.overlay.addChild(this.armature);
        this.overlay.addChild(this.loadingText);

        this.scene.addGameObject(this.container);

        StartAnimation(this.armature, 'DragonbonesDefault');
    }

    private *transitionIn() {
        this.overlay.getComponent(Interactable).enabled = true;
        yield* PlayAnimation(
            GetAnimationClip('ContainerFadeIn', this.container)
        );
        this.scene.emit(SceneTransition.STARTED);
    }

    private *transitionOut() {
        this.overlay.getComponent(Interactable).enabled = false;
        yield* PlayAnimation(
            GetAnimationClip('ContainerFadeOut', this.container)
        );
        this.scene.emit(SceneTransition.ENDED);
    }

    public init(): void {}

    public handleStateChanged(state: IGameState): void {}

    protected onDestroy(): void {}

    protected onLateUpdate(): void {}

    protected onStop(): void {}

    protected onUpdate(): void {}

    public async preload(): Promise<any> {
        return undefined;
    }
}
